import getSearchParams from '../utils/js/getSearchParams';

const returnTimeout = () => {
    const default_timeout = 5000;
    const time = getSearchParams('time');
    if (time === null || time === '') return default_timeout;
    return parseInt(time, 10);
};

function init() {
    // helper variables
    var c = $('.main-slider');
    if (c.length === 0) return null;
    var pin = $('.main-slider-nav');
    var responsiveSlides = responsiveslides;
    // function to recalculate nav position
    var recalcPlacement = () => {
        var vpTop = $(window).scrollTop();
        var vpBottom = vpTop + $(window).height();
        var cTop = c.offset().top;
        var cBottom = cTop + c.outerHeight();
        if (cBottom >= vpBottom) {
            pin.addClass('fixed');
        } else {
            pin.removeClass('fixed');
        }
    };

    // initialize responsiveSlider
    var $responsiveSlider = $('.main-slider-content');
    var exploreLink;
    var shopNowLink;


        // runs for first slide
        exploreLink = $('.main-slider-content li a .explore-link').first().val();
        if (exploreLink === 'no_link') {
            $('.main-slider-nav .explore-banner').css('display', 'none');
        } else {
            $('.main-slider-nav .explore-banner').attr('href', exploreLink);
            $('.main-slider-nav .shopnow-banner').css('display', 'inline-block');
        }

        shopNowLink = $('.main-slider-content li a .shopnow-link').first().val();
        if (shopNowLink === 'no_link') {
            $('.main-slider-nav .shopnow-banner').css('display', 'none');
        } else {
            $('.main-slider-nav .shopnow-banner').attr('href', shopNowLink);
            $('.main-slider-nav .shopnow-banner').css('display', 'inline-block');
        }


    if (typeof $responsiveSlider.responsiveSlides === 'function') {
        $responsiveSlider.responsiveSlides({
            auto: true,
            nav: true,
            pager: true,
            navContainer: '.main-slider-nav-placehold',
            nextPrevContainer: '.main-slider',
            timeout: returnTimeout(),
            after: () => {
                exploreLink = $('.rslides1_on .explore-link').val();
                if (exploreLink === 'no_link') {
                    $('.main-slider-nav .explore-banner').css('display', 'none');
                } else {
                    $('.main-slider-nav .explore-banner').attr('href', exploreLink);
                    $('.main-slider-nav .explore-banner').css('display', 'inline-block');
                }

                shopNowLink = $('.rslides1_on .shopnow-link').val();
                if (shopNowLink === 'no_link') {
                    $('.main-slider-nav .shopnow-banner').css('display', 'none');
                } else {
                    $('.main-slider-nav .shopnow-banner').attr('href', shopNowLink);
                    $('.main-slider-nav .shopnow-banner').css('display', 'inline-block');
                }
            },
        });
    }


    // recalculate nav
    recalcPlacement();

    const delayedRecalc = utils.debounce(recalcPlacement, 200);

    // recalculate nav on resize or scroll
    $(window).on('scroll.pin', recalcPlacement);
    $(window).on('resize.pin', delayedRecalc);

    // if next section button is press smooth scroll to position just after the mainslider
    // (removed from frontpage)
    // c.on('click', '.main-slider-down', function () {
    //     var pageOffset = parseInt($('body').css('padding-top'),10) || 0;
    //     var pos = c.offset().top + c.outerHeight() - pageOffset;
    //     TweenLite.to(window, .5, {scrollTo: {y: pos, autoKill: false}, ease: Power2.easeOut});
    // });
}

init();
